import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { StoryblokImage, StoryblokButton, BannerSponsoring } from '../../models';
import { MediaObserver } from '@angular/flex-layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MEDIA_ALISES } from '~shared/constants/media.constant';
import { environment } from '~env/environment';
import { NUMBER_0 } from '~shared/constants';
import { GtmDatalayerService } from '~shared/services/gtm-datalayer.service';
import { GATrackingEventType } from '~shared/modules/ga-tracking/constants';

enum BannerBGColor {
  WHITE = 'white',
  BLUE = 'blue',
}

enum BannerImagePosition {
  RIGHT = 'right',
  LEFT = 'left',
}

@Component({
  selector: 'app-hero-banner',
  templateUrl: './hero-banner.component.html',
  styleUrls: ['./hero-banner.component.scss'],
})
export class HeroBannerComponent implements OnInit, OnDestroy {
  @Input() _uid: string;
  @Input() title: string;
  @Input() subtext: string;
  @Input() image: StoryblokImage;
  @Input() button: Array<StoryblokButton>;
  @Input() backgroundColor: BannerBGColor;
  @Input() imagePosition: BannerImagePosition;
  @Input() trackingName: string;
  @Input() set sponsor(value: Array<BannerSponsoring>) {
    this._sponsorItem = value?.[NUMBER_0];
  }

  isMobile = true;
  sbFormatParam = '/m/';
  get sponsorItem(): BannerSponsoring {
    return this._sponsorItem;
  }

  private unsubscribe$ = new Subject<void>();
  private readonly marketplaceLink = environment.appBaseUrl();
  private _sponsorItem: BannerSponsoring;

  constructor(
    private mediaObserver: MediaObserver,
    private cd: ChangeDetectorRef,
    private gtmDatalayerService: GtmDatalayerService
  ) {}

  ngOnInit(): void {
    this.initMediaObserver();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private initMediaObserver(): void {
    this.mediaObserver
      .asObservable()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.isMobile = this.mediaObserver.isActive(MEDIA_ALISES.mobile);
        this.cd.markForCheck();
      });
  }

  private loadGenericGaSchema(): { [key: string]: string | object } {
    return {
      ecommerce: {
        creative_name: 'Hero Banner',
        creative_slot: this.trackingName,
        promotion_name: this.title,
        promotion_id: this._uid,
        ...(this.sponsorItem?.isSponsored && {
          items: [
            {
              item_id: this.sponsorItem._uid,
              item_name: this.sponsorItem.advertiserPayerName,
              item_seller: this.sponsorItem.advertiserName,
            },
          ],
        }),
      },
    };
  }

  navigateTo(): void {
    if (this.button.length) {
      this.button[0].isExternalLink
        ? window.open(this.button[0].link, '_blank')
        : (window.location.href = this.marketplaceLink + this.button[0].link);
    }
  }

  fireSelectPromoGAEvent(): void {
    this.gtmDatalayerService.gtagEvent({
      event: GATrackingEventType.SelectPromotion,
      ...this.loadGenericGaSchema(),
    });
  }

  fireViewPromoGAEvent(): void {
    this.gtmDatalayerService.gtagEvent({
      event: GATrackingEventType.ViewPromotion,
      ...this.loadGenericGaSchema(),
    });
  }
}
